import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { IUpdate } from '../models/update.interface';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ErrordialogComponent } from '../../../shared/components/errordialog/errordialog.component';
import { UtilityService } from '../../../services/utility.service';
import { AccountService } from 'src/app/services/account.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'upsc-update',
  templateUrl: './update.component.html',
  styleUrls: ['./update.component.scss']
})
export class UpdateComponent implements OnInit {
  public update: IUpdate = {};
  public worngPassword: boolean = false;
  showErrorMessages: boolean = false;
  passwordNotMatch: boolean = false;
  resetSucceeded: boolean = false;
  public isCanadaUser: boolean;

  systemError: boolean = false;
  loading: boolean = false;
  successMessage: boolean = false;

  constructor(
    private accountService: AccountService,
    private userService: UserService,
    public dialog: MatDialog,
    private utilService: UtilityService
  ) {
    this.tooltipPosition$ = this.utilService.tooltipPositionWatch();
    this.isCanadaUser = this.userService.isCanadaUser();
  }
  @Output() isCancel = new EventEmitter<boolean>();
  public hide: boolean = true;
  public hide2: boolean = true;
  public hide3: boolean = true;
  public tooltipPosition$: any;

  ngOnInit() { }

  auth0ResetPassword() {
    this.systemError = false;
    this.loading = true;
    this.accountService.changePassword().subscribe(
      response => {
        this.loading = false;
        console.log(response);
        this.successMessage = true;
      }, error => {
        this.loading = false;
        this.systemError = true;
      }
    );
  }

  errorDialog() {
    let dialogRef = this.dialog.open(ErrordialogComponent);
    dialogRef.afterClosed().subscribe(result => {});
  }

  public cancel() {
    this.isCancel.emit(true);
  }
}
